// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"3731": "5ef30f976fb4","52": "4c498f6f75a9","8010": "e451f738f266","8357": "dd422574e14d","9731": "815cbfe3f641",}[chunkId] + ".css"
}